import Wordwalk from './Wordwalk.vue';
import WordwalkList from './WordwalkList.vue';
export default {
  Wordwalk,
  WordwalkList,
};
